import React from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../../constants/aampeTheme';

interface StyledProps {
    isDisabled?: boolean;
}
interface SettingsContainerProps {
    children: any;
    isDisabled?: boolean;
}

const SettingsContainer: React.FC<
    React.PropsWithChildren<SettingsContainerProps>
> = ({ children, isDisabled }) => {
    return <Container isDisabled={isDisabled}>{children}</Container>;
};

export default SettingsContainer;

const Container = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'isDisabled',
})<StyledProps>(({ isDisabled }) => ({
    border: `1px solid ${aampeTheme.colors.bordersWG01}`,
    borderRadius: '5px',
    backgroundColor: isDisabled
        ? aampeTheme.colors.backgroundWG01
        : aampeTheme.colors.white,
    color: aampeTheme.colors.gray800,
    fontSize: '14px',
    fontWeight: 400,
    padding: aampeTheme.spacing(3),
}));
